module.exports = "https://la-static.vkplay.ru/promo/thefirst/img/knight-1.2ab0804e.png";